//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export class Client {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {

    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";

  }

  /**
   * @param body (optional) 
   * @return Success
   */
  login(body: LoginCredentials | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/Account/login";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLogin(_response);
    });
  }

  protected processLogin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  logout(cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/Account/logout";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLogout(_response);
    });
  }

  protected processLogout(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  context(cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/Account/context";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processContext(_response);
    });
  }

  protected processContext(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  token(body: LoginCredentials | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/Account/token";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processToken(_response);
    });
  }

  protected processToken(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param returnUrl (optional) 
   * @return Success
   */
  account(returnUrl: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/Account?";
    if (returnUrl !== undefined && returnUrl !== null)
      url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processAccount(_response);
    });
  }

  protected processAccount(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param plantCode (optional) 
   * @param projectId (optional) 
   * @return Success
   */
  activeProject_GetAll(plantCode: string | null | undefined, projectId: string | null | undefined, cancelToken?: CancelToken): Promise<ActiveProjectDto[]> {
    let url_ = this.baseUrl + "/api/ActiveProject?";
    if (plantCode !== undefined && plantCode !== null)
      url_ += "plantCode=" + encodeURIComponent("" + plantCode) + "&";
    if (projectId !== undefined && projectId !== null)
      url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processActiveProject_GetAll(_response);
    });
  }

  protected processActiveProject_GetAll(response: AxiosResponse): Promise<ActiveProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ActiveProjectDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ActiveProjectDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ActiveProjectDto[]>(null as any);
  }

  /**
   * @return Success
   */
  checklistAreas_GetAll(cancelToken?: CancelToken): Promise<ChecklistAreaDto[]> {
    let url_ = this.baseUrl + "/api/ChecklistAreas";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_GetAll(_response);
    });
  }

  protected processChecklistAreas_GetAll(response: AxiosResponse): Promise<ChecklistAreaDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistAreaDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ChecklistAreaDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Post(body: ChecklistAreaDto | undefined, cancelToken?: CancelToken): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Post(_response);
    });
  }

  protected processChecklistAreas_Post(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return Promise.resolve<ChecklistAreaDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(null as any);
  }

  /**
   * @return Success
   */
  checklistAreas_GetById(id: number, cancelToken?: CancelToken): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_GetById(_response);
    });
  }

  protected processChecklistAreas_GetById(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return Promise.resolve<ChecklistAreaDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Put(id: number, body: ChecklistAreaDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Put(_response);
    });
  }

  protected processChecklistAreas_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistAreas_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Patch(_response);
    });
  }

  protected processChecklistAreas_Patch(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return Promise.resolve<ChecklistAreaDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(null as any);
  }

  /**
   * @return Success
   */
  checklistAreas_Delete(id: number, cancelToken?: CancelToken): Promise<ChecklistAreaDto> {
    let url_ = this.baseUrl + "/api/ChecklistAreas/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistAreas_Delete(_response);
    });
  }

  protected processChecklistAreas_Delete(response: AxiosResponse): Promise<ChecklistAreaDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistAreaDto.fromJS(resultData200);
      return Promise.resolve<ChecklistAreaDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistAreaDto>(null as any);
  }

  /**
   * @param search (optional) 
   * @param template (optional) 
   * @param archived (optional) 
   * @param facilityCode (optional) 
   * @param projectTypeCode (optional) 
   * @return Success
   */
  checklistProjects_GetAll(search: string | null | undefined, template: boolean | undefined, archived: boolean | undefined, facilityCode: string | null | undefined, projectTypeCode: string | null | undefined, cancelToken?: CancelToken): Promise<ChecklistProjectDto[]> {
    let url_ = this.baseUrl + "/api/ChecklistProjects?";
    if (search !== undefined && search !== null)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    if (template === null)
      throw new Error("The parameter 'template' cannot be null.");
    else if (template !== undefined)
      url_ += "template=" + encodeURIComponent("" + template) + "&";
    if (archived === null)
      throw new Error("The parameter 'archived' cannot be null.");
    else if (archived !== undefined)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (projectTypeCode !== undefined && projectTypeCode !== null)
      url_ += "projectTypeCode=" + encodeURIComponent("" + projectTypeCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_GetAll(_response);
    });
  }

  protected processChecklistProjects_GetAll(response: AxiosResponse): Promise<ChecklistProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistProjectDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ChecklistProjectDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Post(body: ChecklistProjectDto | undefined, cancelToken?: CancelToken): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Post(_response);
    });
  }

  protected processChecklistProjects_Post(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return Promise.resolve<ChecklistProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(null as any);
  }

  /**
   * @param details (optional) 
   * @return Success
   */
  checklistProjects_GetById(id: number, details: boolean | undefined, cancelToken?: CancelToken): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (details === null)
      throw new Error("The parameter 'details' cannot be null.");
    else if (details !== undefined)
      url_ += "details=" + encodeURIComponent("" + details) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_GetById(_response);
    });
  }

  protected processChecklistProjects_GetById(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return Promise.resolve<ChecklistProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Put(id: number, body: ChecklistProjectDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Put(_response);
    });
  }

  protected processChecklistProjects_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklistProjects_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Patch(_response);
    });
  }

  protected processChecklistProjects_Patch(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return Promise.resolve<ChecklistProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(null as any);
  }

  /**
   * @return Success
   */
  checklistProjects_Delete(id: number, cancelToken?: CancelToken): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Delete(_response);
    });
  }

  protected processChecklistProjects_Delete(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return Promise.resolve<ChecklistProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(null as any);
  }

  /**
   * @return Success
   */
  checklistProjects_Details(id: number, cancelToken?: CancelToken): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}/details";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_Details(_response);
    });
  }

  protected processChecklistProjects_Details(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return Promise.resolve<ChecklistProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(null as any);
  }

  /**
   * @param newProjectName (optional) 
   * @param projectTypeCode (optional) 
   * @param asTemplate (optional) 
   * @param facilityCode (optional) 
   * @param jobId (optional) 
   * @param options (optional) 
   * @return Success
   */
  checklistProjects_CloneTemplate(id: number, newProjectName: string | null | undefined, projectTypeCode: string | null | undefined, asTemplate: boolean | undefined, facilityCode: string | null | undefined, jobId: number | null | undefined, options: string | null | undefined, cancelToken?: CancelToken): Promise<ChecklistProjectDto> {
    let url_ = this.baseUrl + "/api/ChecklistProjects/{id}/clone?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newProjectName !== undefined && newProjectName !== null)
      url_ += "newProjectName=" + encodeURIComponent("" + newProjectName) + "&";
    if (projectTypeCode !== undefined && projectTypeCode !== null)
      url_ += "projectTypeCode=" + encodeURIComponent("" + projectTypeCode) + "&";
    if (asTemplate === null)
      throw new Error("The parameter 'asTemplate' cannot be null.");
    else if (asTemplate !== undefined)
      url_ += "asTemplate=" + encodeURIComponent("" + asTemplate) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (jobId !== undefined && jobId !== null)
      url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
    if (options !== undefined && options !== null)
      url_ += "options=" + encodeURIComponent("" + options) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklistProjects_CloneTemplate(_response);
    });
  }

  protected processChecklistProjects_CloneTemplate(response: AxiosResponse): Promise<ChecklistProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistProjectDto.fromJS(resultData200);
      return Promise.resolve<ChecklistProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto>(null as any);
  }

  /**
   * @param checklistType (optional) 
   * @return Success
   */
  checklists_GetAll(checklistType: ChecklistType | null | undefined, cancelToken?: CancelToken): Promise<ChecklistDto[]> {
    let url_ = this.baseUrl + "/api/Checklists?";
    if (checklistType !== undefined && checklistType !== null)
      url_ += "checklistType=" + encodeURIComponent("" + checklistType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_GetAll(_response);
    });
  }

  protected processChecklists_GetAll(response: AxiosResponse): Promise<ChecklistDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ChecklistDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Post(body: ChecklistDto | undefined, cancelToken?: CancelToken): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Post(_response);
    });
  }

  protected processChecklists_Post(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return Promise.resolve<ChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(null as any);
  }

  /**
   * @param details (optional) 
   * @return Success
   */
  checklists_GetById(id: number, details: boolean | undefined, cancelToken?: CancelToken): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (details === null)
      throw new Error("The parameter 'details' cannot be null.");
    else if (details !== undefined)
      url_ += "details=" + encodeURIComponent("" + details) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_GetById(_response);
    });
  }

  protected processChecklists_GetById(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return Promise.resolve<ChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Put(id: number, body: ChecklistDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Checklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Put(_response);
    });
  }

  protected processChecklists_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  checklists_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Patch(_response);
    });
  }

  protected processChecklists_Patch(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return Promise.resolve<ChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(null as any);
  }

  /**
   * @return Success
   */
  checklists_Delete(id: number, cancelToken?: CancelToken): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_Delete(_response);
    });
  }

  protected processChecklists_Delete(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return Promise.resolve<ChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(null as any);
  }

  /**
   * @param newChecklistName (optional) 
   * @return Success
   */
  checklists_CreateTemplateFromChecklist(id: number, newChecklistName: string | null | undefined, cancelToken?: CancelToken): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/Checklists/{id}/template?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newChecklistName !== undefined && newChecklistName !== null)
      url_ += "newChecklistName=" + encodeURIComponent("" + newChecklistName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processChecklists_CreateTemplateFromChecklist(_response);
    });
  }

  protected processChecklists_CreateTemplateFromChecklist(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return Promise.resolve<RepetitiveChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(null as any);
  }

  /**
   * @return Success
   */
  dWMachine_GetAll(cancelToken?: CancelToken): Promise<MachineDto[]> {
    let url_ = this.baseUrl + "/api/DWMachine";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWMachine_GetAll(_response);
    });
  }

  protected processDWMachine_GetAll(response: AxiosResponse): Promise<MachineDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MachineDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<MachineDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MachineDto[]>(null as any);
  }

  /**
   * @return Success
   */
  dWMachine_Get(facilityCode: string | null, cancelToken?: CancelToken): Promise<MachineDto[]> {
    let url_ = this.baseUrl + "/api/DWMachine/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWMachine_Get(_response);
    });
  }

  protected processDWMachine_Get(response: AxiosResponse): Promise<MachineDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MachineDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<MachineDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MachineDto[]>(null as any);
  }

  /**
   * @return Success
   */
  dWPlant_GetAll(cancelToken?: CancelToken): Promise<FacilityDto[]> {
    let url_ = this.baseUrl + "/api/DWPlant";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWPlant_GetAll(_response);
    });
  }

  protected processDWPlant_GetAll(response: AxiosResponse): Promise<FacilityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FacilityDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<FacilityDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto[]>(null as any);
  }

  /**
   * @return Success
   */
  dWPlant_GetByFacilityCode(facilityCode: string | null, cancelToken?: CancelToken): Promise<FacilityDto> {
    let url_ = this.baseUrl + "/api/DWPlant/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDWPlant_GetByFacilityCode(_response);
    });
  }

  protected processDWPlant_GetByFacilityCode(response: AxiosResponse): Promise<FacilityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FacilityDto.fromJS(resultData200);
      return Promise.resolve<FacilityDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto>(null as any);
  }

  /**
   * @param includeArchived (optional) 
   * @return Success
   */
  facilities_GetAll(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<FacilityDto[]> {
    let url_ = this.baseUrl + "/api/Facilities?";
    if (includeArchived === null)
      throw new Error("The parameter 'includeArchived' cannot be null.");
    else if (includeArchived !== undefined)
      url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_GetAll(_response);
    });
  }

  protected processFacilities_GetAll(response: AxiosResponse): Promise<FacilityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FacilityDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<FacilityDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Post(body: FacilityDto | undefined, cancelToken?: CancelToken): Promise<FacilityDto> {
    let url_ = this.baseUrl + "/api/Facilities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_Post(_response);
    });
  }

  protected processFacilities_Post(response: AxiosResponse): Promise<FacilityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FacilityDto.fromJS(resultData200);
      return Promise.resolve<FacilityDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto>(null as any);
  }

  /**
   * @return Success
   */
  facilities_GetByFacilityCode(facilityCode: string | null, cancelToken?: CancelToken): Promise<FacilityDto> {
    let url_ = this.baseUrl + "/api/Facilities/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_GetByFacilityCode(_response);
    });
  }

  protected processFacilities_GetByFacilityCode(response: AxiosResponse): Promise<FacilityDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FacilityDto.fromJS(resultData200);
      return Promise.resolve<FacilityDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FacilityDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Put(facilityCode: string | null, body: FacilityDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Facilities/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_Put(_response);
    });
  }

  protected processFacilities_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  facilities_Patch(facilityCode: string | null, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Facilities/{facilityCode}";
    if (facilityCode === undefined || facilityCode === null)
      throw new Error("The parameter 'facilityCode' must be defined.");
    url_ = url_.replace("{facilityCode}", encodeURIComponent("" + facilityCode));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processFacilities_Patch(_response);
    });
  }

  protected processFacilities_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param questionId (optional) 
   * @param projectId (optional) 
   * @return Success
   */
  issues_GetAll(questionId: number | null | undefined, projectId: number | null | undefined, cancelToken?: CancelToken): Promise<IssueDto[]> {
    let url_ = this.baseUrl + "/api/Issues?";
    if (questionId !== undefined && questionId !== null)
      url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
    if (projectId !== undefined && projectId !== null)
      url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_GetAll(_response);
    });
  }

  protected processIssues_GetAll(response: AxiosResponse): Promise<IssueDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(IssueDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<IssueDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Post(body: IssueDto | undefined, cancelToken?: CancelToken): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Post(_response);
    });
  }

  protected processIssues_Post(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return Promise.resolve<IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(null as any);
  }

  /**
   * @return Success
   */
  issues_GetById(id: number, cancelToken?: CancelToken): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_GetById(_response);
    });
  }

  protected processIssues_GetById(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return Promise.resolve<IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Put(id: number, body: IssueDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Put(_response);
    });
  }

  protected processIssues_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  issues_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Patch(_response);
    });
  }

  protected processIssues_Patch(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return Promise.resolve<IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(null as any);
  }

  /**
   * @return Success
   */
  issues_Delete(id: number, cancelToken?: CancelToken): Promise<IssueDto> {
    let url_ = this.baseUrl + "/api/Issues/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processIssues_Delete(_response);
    });
  }

  protected processIssues_Delete(response: AxiosResponse): Promise<IssueDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = IssueDto.fromJS(resultData200);
      return Promise.resolve<IssueDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<IssueDto>(null as any);
  }

  /**
   * @param archived (optional) 
   * @param facilityCode (optional) 
   * @param relatedToId (optional) 
   * @return Success
   */
  job_GetAll(archived: boolean | undefined, facilityCode: string | null | undefined, relatedToId: number | undefined, cancelToken?: CancelToken): Promise<JobDto[]> {
    let url_ = this.baseUrl + "/api/Job?";
    if (archived === null)
      throw new Error("The parameter 'archived' cannot be null.");
    else if (archived !== undefined)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (relatedToId === null)
      throw new Error("The parameter 'relatedToId' cannot be null.");
    else if (relatedToId !== undefined)
      url_ += "relatedToId=" + encodeURIComponent("" + relatedToId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_GetAll(_response);
    });
  }

  protected processJob_GetAll(response: AxiosResponse): Promise<JobDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(JobDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<JobDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  job_Post(body: JobDto | undefined, cancelToken?: CancelToken): Promise<JobDto> {
    let url_ = this.baseUrl + "/api/Job";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_Post(_response);
    });
  }

  protected processJob_Post(response: AxiosResponse): Promise<JobDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobDto.fromJS(resultData200);
      return Promise.resolve<JobDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto>(null as any);
  }

  /**
   * @return Success
   */
  job_GetById(jobId: number, cancelToken?: CancelToken): Promise<JobDto> {
    let url_ = this.baseUrl + "/api/Job/{jobId}";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_GetById(_response);
    });
  }

  protected processJob_GetById(response: AxiosResponse): Promise<JobDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobDto.fromJS(resultData200);
      return Promise.resolve<JobDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  job_Put(jobId: number, body: JobDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Job/{jobId}";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_Put(_response);
    });
  }

  protected processJob_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  job_Patch(jobId: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<JobDto> {
    let url_ = this.baseUrl + "/api/Job/{jobId}";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_Patch(_response);
    });
  }

  protected processJob_Patch(response: AxiosResponse): Promise<JobDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobDto.fromJS(resultData200);
      return Promise.resolve<JobDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto>(null as any);
  }

  /**
   * @return Success
   */
  job_Delete(jobId: number, cancelToken?: CancelToken): Promise<JobDto> {
    let url_ = this.baseUrl + "/api/Job/{jobId}";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_Delete(_response);
    });
  }

  protected processJob_Delete(response: AxiosResponse): Promise<JobDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobDto.fromJS(resultData200);
      return Promise.resolve<JobDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto>(null as any);
  }

  /**
   * @return Success
   */
  job_ArchiveJob(jobId: number, cancelToken?: CancelToken): Promise<JobDto> {
    let url_ = this.baseUrl + "/api/Job/{jobId}/archive";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_ArchiveJob(_response);
    });
  }

  protected processJob_ArchiveJob(response: AxiosResponse): Promise<JobDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobDto.fromJS(resultData200);
      return Promise.resolve<JobDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto>(null as any);
  }

  /**
   * @return Success
   */
  job_UnarchiveJob(jobId: number, cancelToken?: CancelToken): Promise<JobDto> {
    let url_ = this.baseUrl + "/api/Job/{jobId}/unarchive";
    if (jobId === undefined || jobId === null)
      throw new Error("The parameter 'jobId' must be defined.");
    url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "PUT",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJob_UnarchiveJob(_response);
    });
  }

  protected processJob_UnarchiveJob(response: AxiosResponse): Promise<JobDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobDto.fromJS(resultData200);
      return Promise.resolve<JobDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobDto>(null as any);
  }

  /**
   * @param archived (optional) 
   * @param facilityCode (optional) 
   * @return Success
   */
  jobTemplate_GetAll(archived: boolean | undefined, facilityCode: string | null | undefined, cancelToken?: CancelToken): Promise<JobTemplateDto[]> {
    let url_ = this.baseUrl + "/api/JobTemplate?";
    if (archived === null)
      throw new Error("The parameter 'archived' cannot be null.");
    else if (archived !== undefined)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_GetAll(_response);
    });
  }

  protected processJobTemplate_GetAll(response: AxiosResponse): Promise<JobTemplateDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(JobTemplateDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<JobTemplateDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobTemplateDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  jobTemplate_Post(body: JobTemplateDto | undefined, cancelToken?: CancelToken): Promise<JobTemplateDto> {
    let url_ = this.baseUrl + "/api/JobTemplate";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_Post(_response);
    });
  }

  protected processJobTemplate_Post(response: AxiosResponse): Promise<JobTemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobTemplateDto.fromJS(resultData200);
      return Promise.resolve<JobTemplateDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobTemplateDto>(null as any);
  }

  /**
   * @return Success
   */
  jobTemplate_GetById(jobTemplateId: number, cancelToken?: CancelToken): Promise<JobTemplateDto> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_GetById(_response);
    });
  }

  protected processJobTemplate_GetById(response: AxiosResponse): Promise<JobTemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobTemplateDto.fromJS(resultData200);
      return Promise.resolve<JobTemplateDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobTemplateDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  jobTemplate_Put(jobTemplateId: number, body: JobTemplateDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_Put(_response);
    });
  }

  protected processJobTemplate_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  jobTemplate_Patch(jobTemplateId: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<JobTemplateDto> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_Patch(_response);
    });
  }

  protected processJobTemplate_Patch(response: AxiosResponse): Promise<JobTemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobTemplateDto.fromJS(resultData200);
      return Promise.resolve<JobTemplateDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobTemplateDto>(null as any);
  }

  /**
   * @return Success
   */
  jobTemplate_Delete(jobTemplateId: number, cancelToken?: CancelToken): Promise<JobTemplateDto> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_Delete(_response);
    });
  }

  protected processJobTemplate_Delete(response: AxiosResponse): Promise<JobTemplateDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobTemplateDto.fromJS(resultData200);
      return Promise.resolve<JobTemplateDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobTemplateDto>(null as any);
  }

  /**
   * @return Success
   */
  jobTemplate_GetAllTemplateJobs(jobTemplateId: number, cancelToken?: CancelToken): Promise<ChecklistProjectDto[]> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}/TemplateJobs";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_GetAllTemplateJobs(_response);
    });
  }

  protected processJobTemplate_GetAllTemplateJobs(response: AxiosResponse): Promise<ChecklistProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistProjectDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ChecklistProjectDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto[]>(null as any);
  }

  /**
   * @param projectTypeCode (optional) 
   * @param conditions (optional) 
   * @param sortOrder (optional) 
   * @return Success
   */
  jobTemplate_UpsertTemplateJob(jobTemplateId: number, id: number, projectTypeCode: string | null | undefined, conditions: string | null | undefined, sortOrder: number | undefined, cancelToken?: CancelToken): Promise<JobChecklistProject> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}/TemplateJob/{id}?";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (projectTypeCode !== undefined && projectTypeCode !== null)
      url_ += "projectTypeCode=" + encodeURIComponent("" + projectTypeCode) + "&";
    if (conditions !== undefined && conditions !== null)
      url_ += "conditions=" + encodeURIComponent("" + conditions) + "&";
    if (sortOrder === null)
      throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
      url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_UpsertTemplateJob(_response);
    });
  }

  protected processJobTemplate_UpsertTemplateJob(response: AxiosResponse): Promise<JobChecklistProject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobChecklistProject.fromJS(resultData200);
      return Promise.resolve<JobChecklistProject>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobChecklistProject>(null as any);
  }

  /**
   * @param projectTypeCode (optional) 
   * @return Success
   */
  jobTemplate_RemoveTemplateJob(jobTemplateId: number, id: number, projectTypeCode: string | null | undefined, cancelToken?: CancelToken): Promise<JobChecklistProject> {
    let url_ = this.baseUrl + "/api/JobTemplate/{jobTemplateId}/TemplateJob/{id}?";
    if (jobTemplateId === undefined || jobTemplateId === null)
      throw new Error("The parameter 'jobTemplateId' must be defined.");
    url_ = url_.replace("{jobTemplateId}", encodeURIComponent("" + jobTemplateId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (projectTypeCode !== undefined && projectTypeCode !== null)
      url_ += "projectTypeCode=" + encodeURIComponent("" + projectTypeCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processJobTemplate_RemoveTemplateJob(_response);
    });
  }

  protected processJobTemplate_RemoveTemplateJob(response: AxiosResponse): Promise<JobChecklistProject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JobChecklistProject.fromJS(resultData200);
      return Promise.resolve<JobChecklistProject>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<JobChecklistProject>(null as any);
  }

  /**
   * @return Success
   */
  lookupLists_GetAll(cancelToken?: CancelToken): Promise<LookupListDto[]> {
    let url_ = this.baseUrl + "/api/LookupLists";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_GetAll(_response);
    });
  }

  protected processLookupLists_GetAll(response: AxiosResponse): Promise<LookupListDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(LookupListDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<LookupListDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Post(body: LookupListDto | undefined, cancelToken?: CancelToken): Promise<LookupListDto> {
    let url_ = this.baseUrl + "/api/LookupLists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Post(_response);
    });
  }

  protected processLookupLists_Post(response: AxiosResponse): Promise<LookupListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LookupListDto.fromJS(resultData200);
      return Promise.resolve<LookupListDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto>(null as any);
  }

  /**
   * @return Success
   */
  lookupLists_GetById(id: number, cancelToken?: CancelToken): Promise<LookupListDto> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_GetById(_response);
    });
  }

  protected processLookupLists_GetById(response: AxiosResponse): Promise<LookupListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LookupListDto.fromJS(resultData200);
      return Promise.resolve<LookupListDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Put(id: number, body: LookupListDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Put(_response);
    });
  }

  protected processLookupLists_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  lookupLists_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Patch(_response);
    });
  }

  protected processLookupLists_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  lookupLists_Delete(id: number, cancelToken?: CancelToken): Promise<LookupListDto> {
    let url_ = this.baseUrl + "/api/LookupLists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processLookupLists_Delete(_response);
    });
  }

  protected processLookupLists_Delete(response: AxiosResponse): Promise<LookupListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = LookupListDto.fromJS(resultData200);
      return Promise.resolve<LookupListDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<LookupListDto>(null as any);
  }

  /**
   * @return Success
   */
  moreInfo_GetAll(cancelToken?: CancelToken): Promise<QuestionMoreInfoDto[]> {
    let url_ = this.baseUrl + "/api/MoreInfo";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_GetAll(_response);
    });
  }

  protected processMoreInfo_GetAll(response: AxiosResponse): Promise<QuestionMoreInfoDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuestionMoreInfoDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<QuestionMoreInfoDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Post(body: QuestionMoreInfoDto | undefined, cancelToken?: CancelToken): Promise<QuestionMoreInfoDto> {
    let url_ = this.baseUrl + "/api/MoreInfo";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Post(_response);
    });
  }

  protected processMoreInfo_Post(response: AxiosResponse): Promise<QuestionMoreInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionMoreInfoDto.fromJS(resultData200);
      return Promise.resolve<QuestionMoreInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto>(null as any);
  }

  /**
   * @return Success
   */
  moreInfo_GetById(id: number, cancelToken?: CancelToken): Promise<QuestionMoreInfoDto> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_GetById(_response);
    });
  }

  protected processMoreInfo_GetById(response: AxiosResponse): Promise<QuestionMoreInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionMoreInfoDto.fromJS(resultData200);
      return Promise.resolve<QuestionMoreInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Put(id: number, body: QuestionMoreInfoDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Put(_response);
    });
  }

  protected processMoreInfo_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  moreInfo_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Patch(_response);
    });
  }

  protected processMoreInfo_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  moreInfo_Delete(id: number, cancelToken?: CancelToken): Promise<QuestionMoreInfoDto> {
    let url_ = this.baseUrl + "/api/MoreInfo/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processMoreInfo_Delete(_response);
    });
  }

  protected processMoreInfo_Delete(response: AxiosResponse): Promise<QuestionMoreInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionMoreInfoDto.fromJS(resultData200);
      return Promise.resolve<QuestionMoreInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionMoreInfoDto>(null as any);
  }

  /**
   * @param template (optional) 
   * @param archived (optional) 
   * @param facilityCode (optional) 
   * @return Success
   */
  project_GetAll(template: boolean | undefined, archived: boolean | undefined, facilityCode: string | null | undefined, cancelToken?: CancelToken): Promise<ProjectDto[]> {
    let url_ = this.baseUrl + "/api/Project?";
    if (template === null)
      throw new Error("The parameter 'template' cannot be null.");
    else if (template !== undefined)
      url_ += "template=" + encodeURIComponent("" + template) + "&";
    if (archived === null)
      throw new Error("The parameter 'archived' cannot be null.");
    else if (archived !== undefined)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_GetAll(_response);
    });
  }

  protected processProject_GetAll(response: AxiosResponse): Promise<ProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProjectDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ProjectDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  project_Post(body: ProjectDto | undefined, cancelToken?: CancelToken): Promise<ProjectDto> {
    let url_ = this.baseUrl + "/api/Project";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_Post(_response);
    });
  }

  protected processProject_Post(response: AxiosResponse): Promise<ProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectDto.fromJS(resultData200);
      return Promise.resolve<ProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectDto>(null as any);
  }

  /**
   * @return Success
   */
  project_GetById(projectId: string | null, cancelToken?: CancelToken): Promise<ProjectDto> {
    let url_ = this.baseUrl + "/api/Project/{projectId}";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_GetById(_response);
    });
  }

  protected processProject_GetById(response: AxiosResponse): Promise<ProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectDto.fromJS(resultData200);
      return Promise.resolve<ProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  project_Put(projectId: string | null, body: ProjectDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Project/{projectId}";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_Put(_response);
    });
  }

  protected processProject_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  project_Patch(projectId: string | null, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<ProjectDto> {
    let url_ = this.baseUrl + "/api/Project/{projectId}";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_Patch(_response);
    });
  }

  protected processProject_Patch(response: AxiosResponse): Promise<ProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectDto.fromJS(resultData200);
      return Promise.resolve<ProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectDto>(null as any);
  }

  /**
   * @return Success
   */
  project_Delete(projectId: string | null, cancelToken?: CancelToken): Promise<ProjectDto> {
    let url_ = this.baseUrl + "/api/Project/{projectId}";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_Delete(_response);
    });
  }

  protected processProject_Delete(response: AxiosResponse): Promise<ProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectDto.fromJS(resultData200);
      return Promise.resolve<ProjectDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectDto>(null as any);
  }

  /**
   * @return Success
   */
  project_GetAllTemplateProjects(projectId: string | null, cancelToken?: CancelToken): Promise<ChecklistProjectDto[]> {
    let url_ = this.baseUrl + "/api/Project/{projectId}/TemplateProjects";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_GetAllTemplateProjects(_response);
    });
  }

  protected processProject_GetAllTemplateProjects(response: AxiosResponse): Promise<ChecklistProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ChecklistProjectDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ChecklistProjectDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistProjectDto[]>(null as any);
  }

  /**
   * @param projectType (optional) 
   * @param conditions (optional) 
   * @param sortOrder (optional) 
   * @return Success
   */
  project_UpsertTemplateProject(projectId: string | null, id: number, projectType: string | null | undefined, conditions: string | null | undefined, sortOrder: number | undefined, cancelToken?: CancelToken): Promise<ProjectChecklistProject> {
    let url_ = this.baseUrl + "/api/Project/{projectId}/TemplateProject/{id}?";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (projectType !== undefined && projectType !== null)
      url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
    if (conditions !== undefined && conditions !== null)
      url_ += "conditions=" + encodeURIComponent("" + conditions) + "&";
    if (sortOrder === null)
      throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
      url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_UpsertTemplateProject(_response);
    });
  }

  protected processProject_UpsertTemplateProject(response: AxiosResponse): Promise<ProjectChecklistProject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectChecklistProject.fromJS(resultData200);
      return Promise.resolve<ProjectChecklistProject>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectChecklistProject>(null as any);
  }

  /**
   * @return Success
   */
  project_RemoveTemplateProject(projectId: string | null, id: number, cancelToken?: CancelToken): Promise<ProjectChecklistProject> {
    let url_ = this.baseUrl + "/api/Project/{projectId}/TemplateProject/{Id}";
    if (projectId === undefined || projectId === null)
      throw new Error("The parameter 'projectId' must be defined.");
    url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProject_RemoveTemplateProject(_response);
    });
  }

  protected processProject_RemoveTemplateProject(response: AxiosResponse): Promise<ProjectChecklistProject> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectChecklistProject.fromJS(resultData200);
      return Promise.resolve<ProjectChecklistProject>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectChecklistProject>(null as any);
  }

  /**
   * @param includeArchived (optional) 
   * @return Success
   */
  projectType_GetAll(includeArchived: boolean | undefined, cancelToken?: CancelToken): Promise<ProjectTypeDto[]> {
    let url_ = this.baseUrl + "/api/ProjectType?";
    if (includeArchived === null)
      throw new Error("The parameter 'includeArchived' cannot be null.");
    else if (includeArchived !== undefined)
      url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProjectType_GetAll(_response);
    });
  }

  protected processProjectType_GetAll(response: AxiosResponse): Promise<ProjectTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ProjectTypeDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ProjectTypeDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectTypeDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  projectType_Post(body: ProjectTypeDto | undefined, cancelToken?: CancelToken): Promise<ProjectTypeDto> {
    let url_ = this.baseUrl + "/api/ProjectType";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProjectType_Post(_response);
    });
  }

  protected processProjectType_Post(response: AxiosResponse): Promise<ProjectTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectTypeDto.fromJS(resultData200);
      return Promise.resolve<ProjectTypeDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectTypeDto>(null as any);
  }

  /**
   * @return Success
   */
  projectType_GetById(code: string | null, cancelToken?: CancelToken): Promise<ProjectTypeDto> {
    let url_ = this.baseUrl + "/api/ProjectType/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProjectType_GetById(_response);
    });
  }

  protected processProjectType_GetById(response: AxiosResponse): Promise<ProjectTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectTypeDto.fromJS(resultData200);
      return Promise.resolve<ProjectTypeDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectTypeDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  projectType_Put(code: string | null, body: ProjectTypeDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/ProjectType/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProjectType_Put(_response);
    });
  }

  protected processProjectType_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  projectType_Patch(code: string | null, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<ProjectTypeDto> {
    let url_ = this.baseUrl + "/api/ProjectType/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProjectType_Patch(_response);
    });
  }

  protected processProjectType_Patch(response: AxiosResponse): Promise<ProjectTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectTypeDto.fromJS(resultData200);
      return Promise.resolve<ProjectTypeDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectTypeDto>(null as any);
  }

  /**
   * @return Success
   */
  projectType_Delete(code: number, cancelToken?: CancelToken): Promise<ProjectTypeDto> {
    let url_ = this.baseUrl + "/api/ProjectType/{code}";
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace("{code}", encodeURIComponent("" + code));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processProjectType_Delete(_response);
    });
  }

  protected processProjectType_Delete(response: AxiosResponse): Promise<ProjectTypeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProjectTypeDto.fromJS(resultData200);
      return Promise.resolve<ProjectTypeDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProjectTypeDto>(null as any);
  }

  /**
   * @param areaId (optional) 
   * @return Success
   */
  questions_GetAll(areaId: number | undefined, cancelToken?: CancelToken): Promise<QuestionDto[]> {
    let url_ = this.baseUrl + "/api/Questions?";
    if (areaId === null)
      throw new Error("The parameter 'areaId' cannot be null.");
    else if (areaId !== undefined)
      url_ += "areaId=" + encodeURIComponent("" + areaId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_GetAll(_response);
    });
  }

  protected processQuestions_GetAll(response: AxiosResponse): Promise<QuestionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuestionDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<QuestionDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Post(body: QuestionDto | undefined, cancelToken?: CancelToken): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Post(_response);
    });
  }

  protected processQuestions_Post(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return Promise.resolve<QuestionDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @return Success
   */
  questions_GetById(id: number, cancelToken?: CancelToken): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_GetById(_response);
    });
  }

  protected processQuestions_GetById(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return Promise.resolve<QuestionDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Put(id: number, body: QuestionDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Put(_response);
    });
  }

  protected processQuestions_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  questions_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Patch(_response);
    });
  }

  protected processQuestions_Patch(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return Promise.resolve<QuestionDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @return Success
   */
  questions_Delete(id: number, cancelToken?: CancelToken): Promise<QuestionDto> {
    let url_ = this.baseUrl + "/api/Questions/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_Delete(_response);
    });
  }

  protected processQuestions_Delete(response: AxiosResponse): Promise<QuestionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionDto.fromJS(resultData200);
      return Promise.resolve<QuestionDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionDto>(null as any);
  }

  /**
   * @return Success
   */
  questions_GetAttachments(questionId: number, cancelToken?: CancelToken): Promise<QuestionAttachmentDto[]> {
    let url_ = this.baseUrl + "/api/Questions/{questionId}/Attachments";
    if (questionId === undefined || questionId === null)
      throw new Error("The parameter 'questionId' must be defined.");
    url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_GetAttachments(_response);
    });
  }

  protected processQuestions_GetAttachments(response: AxiosResponse): Promise<QuestionAttachmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuestionAttachmentDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<QuestionAttachmentDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionAttachmentDto[]>(null as any);
  }

  /**
   * @param checklistProjectId (optional) 
   * @param body (optional) 
   * @return Success
   */
  questions_AddAttachment(questionId: number, checklistProjectId: number | undefined, body: QuestionAttachmentDto | undefined, cancelToken?: CancelToken): Promise<QuestionAttachment> {
    let url_ = this.baseUrl + "/api/Questions/{questionId}/Attachments?";
    if (questionId === undefined || questionId === null)
      throw new Error("The parameter 'questionId' must be defined.");
    url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
    if (checklistProjectId === null)
      throw new Error("The parameter 'checklistProjectId' cannot be null.");
    else if (checklistProjectId !== undefined)
      url_ += "checklistProjectId=" + encodeURIComponent("" + checklistProjectId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_AddAttachment(_response);
    });
  }

  protected processQuestions_AddAttachment(response: AxiosResponse): Promise<QuestionAttachment> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionAttachment.fromJS(resultData200);
      return Promise.resolve<QuestionAttachment>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionAttachment>(null as any);
  }

  /**
   * @return Success
   */
  questions_RemoveAttachment(questionId: number, attachmentId: number, cancelToken?: CancelToken): Promise<QuestionAttachment> {
    let url_ = this.baseUrl + "/api/Questions/{questionId}/Attachments/{attachmentId}";
    if (questionId === undefined || questionId === null)
      throw new Error("The parameter 'questionId' must be defined.");
    url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processQuestions_RemoveAttachment(_response);
    });
  }

  protected processQuestions_RemoveAttachment(response: AxiosResponse): Promise<QuestionAttachment> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuestionAttachment.fromJS(resultData200);
      return Promise.resolve<QuestionAttachment>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<QuestionAttachment>(null as any);
  }

  /**
   * @param facilityCode (optional) 
   * @param projectTypeCode (optional) 
   * @param checklistType (optional) 
   * @param archived (optional) 
   * @return Success
   */
  repetitiveChecklists_GetAll(facilityCode: string | null | undefined, projectTypeCode: string | null | undefined, checklistType: ChecklistType | null | undefined, archived: boolean | null | undefined, cancelToken?: CancelToken): Promise<RepetitiveChecklistDto[]> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists?";
    if (facilityCode !== undefined && facilityCode !== null)
      url_ += "facilityCode=" + encodeURIComponent("" + facilityCode) + "&";
    if (projectTypeCode !== undefined && projectTypeCode !== null)
      url_ += "projectTypeCode=" + encodeURIComponent("" + projectTypeCode) + "&";
    if (checklistType !== undefined && checklistType !== null)
      url_ += "checklistType=" + encodeURIComponent("" + checklistType) + "&";
    if (archived !== undefined && archived !== null)
      url_ += "archived=" + encodeURIComponent("" + archived) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_GetAll(_response);
    });
  }

  protected processRepetitiveChecklists_GetAll(response: AxiosResponse): Promise<RepetitiveChecklistDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(RepetitiveChecklistDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<RepetitiveChecklistDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Post(body: RepetitiveChecklistDto | undefined, cancelToken?: CancelToken): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Post(_response);
    });
  }

  protected processRepetitiveChecklists_Post(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return Promise.resolve<RepetitiveChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(null as any);
  }

  /**
   * @param details (optional) 
   * @return Success
   */
  repetitiveChecklists_GetById(id: number, details: boolean | undefined, cancelToken?: CancelToken): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (details === null)
      throw new Error("The parameter 'details' cannot be null.");
    else if (details !== undefined)
      url_ += "details=" + encodeURIComponent("" + details) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_GetById(_response);
    });
  }

  protected processRepetitiveChecklists_GetById(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return Promise.resolve<RepetitiveChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Put(id: number, body: RepetitiveChecklistDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Put(_response);
    });
  }

  protected processRepetitiveChecklists_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  repetitiveChecklists_Patch(id: number, body: Operation[] | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PATCH",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Patch(_response);
    });
  }

  protected processRepetitiveChecklists_Patch(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  repetitiveChecklists_Delete(id: number, cancelToken?: CancelToken): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_Delete(_response);
    });
  }

  protected processRepetitiveChecklists_Delete(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return Promise.resolve<RepetitiveChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(null as any);
  }

  /**
   * @param projectId (optional) 
   * @param newChecklistName (optional) 
   * @param newType (optional) 
   * @return Success
   */
  repetitiveChecklists_CopyChecklistToProject(id: number, projectId: number | undefined, newChecklistName: string | null | undefined, newType: ChecklistType | null | undefined, cancelToken?: CancelToken): Promise<ChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}/copyto?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (projectId === null)
      throw new Error("The parameter 'projectId' cannot be null.");
    else if (projectId !== undefined)
      url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
    if (newChecklistName !== undefined && newChecklistName !== null)
      url_ += "newChecklistName=" + encodeURIComponent("" + newChecklistName) + "&";
    if (newType !== undefined && newType !== null)
      url_ += "newType=" + encodeURIComponent("" + newType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_CopyChecklistToProject(_response);
    });
  }

  protected processRepetitiveChecklists_CopyChecklistToProject(response: AxiosResponse): Promise<ChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChecklistDto.fromJS(resultData200);
      return Promise.resolve<ChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChecklistDto>(null as any);
  }

  /**
   * @param newChecklistName (optional) 
   * @return Success
   */
  repetitiveChecklists_DuplicateRepetitiveChecklist(id: number, newChecklistName: string | null | undefined, cancelToken?: CancelToken): Promise<RepetitiveChecklistDto> {
    let url_ = this.baseUrl + "/api/RepetitiveChecklists/{id}/duplicate?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (newChecklistName !== undefined && newChecklistName !== null)
      url_ += "newChecklistName=" + encodeURIComponent("" + newChecklistName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processRepetitiveChecklists_DuplicateRepetitiveChecklist(_response);
    });
  }

  protected processRepetitiveChecklists_DuplicateRepetitiveChecklist(response: AxiosResponse): Promise<RepetitiveChecklistDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RepetitiveChecklistDto.fromJS(resultData200);
      return Promise.resolve<RepetitiveChecklistDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<RepetitiveChecklistDto>(null as any);
  }

  /**
   * @return Success
   */
  users_GetAll(cancelToken?: CancelToken): Promise<UserDto[]> {
    let url_ = this.baseUrl + "/api/Users";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_GetAll(_response);
    });
  }

  protected processUsers_GetAll(response: AxiosResponse): Promise<UserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<UserDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto[]>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  users_Post(body: UserDto | undefined, cancelToken?: CancelToken): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/Users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_Post(_response);
    });
  }

  protected processUsers_Post(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return Promise.resolve<UserDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto>(null as any);
  }

  /**
   * @return Success
   */
  users_GetById(id: number, cancelToken?: CancelToken): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_GetById(_response);
    });
  }

  protected processUsers_GetById(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return Promise.resolve<UserDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto>(null as any);
  }

  /**
   * @param body (optional) 
   * @return Success
   */
  users_Put(id: number, body: UserDto | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json-patch+json",
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_Put(_response);
    });
  }

  protected processUsers_Put(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  users_Delete(id: number, cancelToken?: CancelToken): Promise<UserDto> {
    let url_ = this.baseUrl + "/api/Users/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processUsers_Delete(_response);
    });
  }

  protected processUsers_Delete(response: AxiosResponse): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDto.fromJS(resultData200);
      return Promise.resolve<UserDto>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<UserDto>(null as any);
  }
}

export class ActiveProjectDto implements IActiveProjectDto {
  plantCode?: string | null;
  projectId?: string | null;
  tryout?: moment.Moment | null;
  departure?: moment.Moment | null;
  status?: string | null;
  jobType?: string | null;

  constructor(data?: IActiveProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.plantCode = _data["plantCode"] !== undefined ? _data["plantCode"] : <any>null;
      this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
      this.tryout = _data["tryout"] ? moment(_data["tryout"].toString()) : <any>null;
      this.departure = _data["departure"] ? moment(_data["departure"].toString()) : <any>null;
      this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
      this.jobType = _data["jobType"] !== undefined ? _data["jobType"] : <any>null;
    }
  }

  static fromJS(data: any): ActiveProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new ActiveProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["plantCode"] = this.plantCode !== undefined ? this.plantCode : <any>null;
    data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
    data["tryout"] = this.tryout ? this.tryout.toISOString() : <any>null;
    data["departure"] = this.departure ? this.departure.toISOString() : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["jobType"] = this.jobType !== undefined ? this.jobType : <any>null;
    return data;
  }
}

export interface IActiveProjectDto {
  plantCode?: string | null;
  projectId?: string | null;
  tryout?: moment.Moment | null;
  departure?: moment.Moment | null;
  status?: string | null;
  jobType?: string | null;
}

export class ChecklistArea implements IChecklistArea {
  id?: number;
  checklistId?: number | null;
  repetitiveChecklistId?: number | null;
  name!: string;
  description?: string | null;
  questions?: Question[] | null;
  sortOrder?: number;
  conditions?: string | null;
  groupName?: string | null;

  constructor(data?: IChecklistArea) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.checklistId = _data["checklistId"] !== undefined ? _data["checklistId"] : <any>null;
      this.repetitiveChecklistId = _data["repetitiveChecklistId"] !== undefined ? _data["repetitiveChecklistId"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      if (Array.isArray(_data["questions"])) {
        this.questions = [] as any;
        for (let item of _data["questions"])
          this.questions!.push(Question.fromJS(item));
      }
      else {
        this.questions = <any>null;
      }
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : <any>null;
    }
  }

  static fromJS(data: any): ChecklistArea {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistArea();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["checklistId"] = this.checklistId !== undefined ? this.checklistId : <any>null;
    data["repetitiveChecklistId"] = this.repetitiveChecklistId !== undefined ? this.repetitiveChecklistId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    if (Array.isArray(this.questions)) {
      data["questions"] = [];
      for (let item of this.questions)
        data["questions"].push(item.toJSON());
    }
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["groupName"] = this.groupName !== undefined ? this.groupName : <any>null;
    return data;
  }
}

export interface IChecklistArea {
  id?: number;
  checklistId?: number | null;
  repetitiveChecklistId?: number | null;
  name: string;
  description?: string | null;
  questions?: Question[] | null;
  sortOrder?: number;
  conditions?: string | null;
  groupName?: string | null;
}

export class ChecklistAreaDto implements IChecklistAreaDto {
  id?: number;
  checklistId?: number | null;
  repetitiveChecklistId?: number | null;
  name!: string;
  description?: string | null;
  questions?: QuestionDto[] | null;
  sortOrder?: number;
  conditions?: string | null;
  groupName?: string | null;

  constructor(data?: IChecklistAreaDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.checklistId = _data["checklistId"] !== undefined ? _data["checklistId"] : <any>null;
      this.repetitiveChecklistId = _data["repetitiveChecklistId"] !== undefined ? _data["repetitiveChecklistId"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      if (Array.isArray(_data["questions"])) {
        this.questions = [] as any;
        for (let item of _data["questions"])
          this.questions!.push(QuestionDto.fromJS(item));
      }
      else {
        this.questions = <any>null;
      }
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : <any>null;
    }
  }

  static fromJS(data: any): ChecklistAreaDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistAreaDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["checklistId"] = this.checklistId !== undefined ? this.checklistId : <any>null;
    data["repetitiveChecklistId"] = this.repetitiveChecklistId !== undefined ? this.repetitiveChecklistId : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    if (Array.isArray(this.questions)) {
      data["questions"] = [];
      for (let item of this.questions)
        data["questions"].push(item.toJSON());
    }
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["groupName"] = this.groupName !== undefined ? this.groupName : <any>null;
    return data;
  }
}

export interface IChecklistAreaDto {
  id?: number;
  checklistId?: number | null;
  repetitiveChecklistId?: number | null;
  name: string;
  description?: string | null;
  questions?: QuestionDto[] | null;
  sortOrder?: number;
  conditions?: string | null;
  groupName?: string | null;
}

export class ChecklistDto implements IChecklistDto {
  id?: number;
  projectId?: number | null;
  type!: ChecklistType;
  name!: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  conditions?: string | null;
  areas?: ChecklistAreaDto[] | null;
  hidden?: boolean | null;
  allowSignOff?: boolean | null;
  signOffAt?: moment.Moment | null;
  signOffBy?: string | null;
  signOffNotes?: string | null;
  leaderSignOffAt?: moment.Moment | null;
  leaderSignOffBy?: string | null;
  leaderSignOffNotes?: string | null;
  machineId?: string | null;
  machineName?: string | null;
  component?: string | null;
  userEditableName?: boolean | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IChecklistDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      if (Array.isArray(_data["areas"])) {
        this.areas = [] as any;
        for (let item of _data["areas"])
          this.areas!.push(ChecklistAreaDto.fromJS(item));
      }
      else {
        this.areas = <any>null;
      }
      this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : <any>null;
      this.allowSignOff = _data["allowSignOff"] !== undefined ? _data["allowSignOff"] : <any>null;
      this.signOffAt = _data["signOffAt"] ? moment(_data["signOffAt"].toString()) : <any>null;
      this.signOffBy = _data["signOffBy"] !== undefined ? _data["signOffBy"] : <any>null;
      this.signOffNotes = _data["signOffNotes"] !== undefined ? _data["signOffNotes"] : <any>null;
      this.leaderSignOffAt = _data["leaderSignOffAt"] ? moment(_data["leaderSignOffAt"].toString()) : <any>null;
      this.leaderSignOffBy = _data["leaderSignOffBy"] !== undefined ? _data["leaderSignOffBy"] : <any>null;
      this.leaderSignOffNotes = _data["leaderSignOffNotes"] !== undefined ? _data["leaderSignOffNotes"] : <any>null;
      this.machineId = _data["machineId"] !== undefined ? _data["machineId"] : <any>null;
      this.machineName = _data["machineName"] !== undefined ? _data["machineName"] : <any>null;
      this.component = _data["component"] !== undefined ? _data["component"] : <any>null;
      this.userEditableName = _data["userEditableName"] !== undefined ? _data["userEditableName"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): ChecklistDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    if (Array.isArray(this.areas)) {
      data["areas"] = [];
      for (let item of this.areas)
        data["areas"].push(item.toJSON());
    }
    data["hidden"] = this.hidden !== undefined ? this.hidden : <any>null;
    data["allowSignOff"] = this.allowSignOff !== undefined ? this.allowSignOff : <any>null;
    data["signOffAt"] = this.signOffAt ? this.signOffAt.toISOString() : <any>null;
    data["signOffBy"] = this.signOffBy !== undefined ? this.signOffBy : <any>null;
    data["signOffNotes"] = this.signOffNotes !== undefined ? this.signOffNotes : <any>null;
    data["leaderSignOffAt"] = this.leaderSignOffAt ? this.leaderSignOffAt.toISOString() : <any>null;
    data["leaderSignOffBy"] = this.leaderSignOffBy !== undefined ? this.leaderSignOffBy : <any>null;
    data["leaderSignOffNotes"] = this.leaderSignOffNotes !== undefined ? this.leaderSignOffNotes : <any>null;
    data["machineId"] = this.machineId !== undefined ? this.machineId : <any>null;
    data["machineName"] = this.machineName !== undefined ? this.machineName : <any>null;
    data["component"] = this.component !== undefined ? this.component : <any>null;
    data["userEditableName"] = this.userEditableName !== undefined ? this.userEditableName : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IChecklistDto {
  id?: number;
  projectId?: number | null;
  type: ChecklistType;
  name: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  conditions?: string | null;
  areas?: ChecklistAreaDto[] | null;
  hidden?: boolean | null;
  allowSignOff?: boolean | null;
  signOffAt?: moment.Moment | null;
  signOffBy?: string | null;
  signOffNotes?: string | null;
  leaderSignOffAt?: moment.Moment | null;
  leaderSignOffBy?: string | null;
  leaderSignOffNotes?: string | null;
  machineId?: string | null;
  machineName?: string | null;
  component?: string | null;
  userEditableName?: boolean | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class ChecklistProjectDto implements IChecklistProjectDto {
  id?: number;
  name!: string;
  description?: string | null;
  isTemplate?: boolean | null;
  archived?: boolean | null;
  readonly?: boolean | null;
  unresolvedIssues?: number | null;
  progress?: number | null;
  checklists?: ChecklistDto[] | null;
  projectTypeCode?: string | null;
  facilityCode?: string | null;
  projectTypesAllowed?: string[] | null;
  facilityRestrictions?: string[] | null;
  jobId?: number | null;
  options?: string | null;
  conditions?: string | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IChecklistProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.isTemplate = _data["isTemplate"] !== undefined ? _data["isTemplate"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      this.readonly = _data["readonly"] !== undefined ? _data["readonly"] : <any>null;
      this.unresolvedIssues = _data["unresolvedIssues"] !== undefined ? _data["unresolvedIssues"] : <any>null;
      this.progress = _data["progress"] !== undefined ? _data["progress"] : <any>null;
      if (Array.isArray(_data["checklists"])) {
        this.checklists = [] as any;
        for (let item of _data["checklists"])
          this.checklists!.push(ChecklistDto.fromJS(item));
      }
      else {
        this.checklists = <any>null;
      }
      this.projectTypeCode = _data["projectTypeCode"] !== undefined ? _data["projectTypeCode"] : <any>null;
      this.facilityCode = _data["facilityCode"] !== undefined ? _data["facilityCode"] : <any>null;
      if (Array.isArray(_data["projectTypesAllowed"])) {
        this.projectTypesAllowed = [] as any;
        for (let item of _data["projectTypesAllowed"])
          this.projectTypesAllowed!.push(item);
      }
      else {
        this.projectTypesAllowed = <any>null;
      }
      if (Array.isArray(_data["facilityRestrictions"])) {
        this.facilityRestrictions = [] as any;
        for (let item of _data["facilityRestrictions"])
          this.facilityRestrictions!.push(item);
      }
      else {
        this.facilityRestrictions = <any>null;
      }
      this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): ChecklistProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChecklistProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["isTemplate"] = this.isTemplate !== undefined ? this.isTemplate : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["readonly"] = this.readonly !== undefined ? this.readonly : <any>null;
    data["unresolvedIssues"] = this.unresolvedIssues !== undefined ? this.unresolvedIssues : <any>null;
    data["progress"] = this.progress !== undefined ? this.progress : <any>null;
    if (Array.isArray(this.checklists)) {
      data["checklists"] = [];
      for (let item of this.checklists)
        data["checklists"].push(item.toJSON());
    }
    data["projectTypeCode"] = this.projectTypeCode !== undefined ? this.projectTypeCode : <any>null;
    data["facilityCode"] = this.facilityCode !== undefined ? this.facilityCode : <any>null;
    if (Array.isArray(this.projectTypesAllowed)) {
      data["projectTypesAllowed"] = [];
      for (let item of this.projectTypesAllowed)
        data["projectTypesAllowed"].push(item);
    }
    if (Array.isArray(this.facilityRestrictions)) {
      data["facilityRestrictions"] = [];
      for (let item of this.facilityRestrictions)
        data["facilityRestrictions"].push(item);
    }
    data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IChecklistProjectDto {
  id?: number;
  name: string;
  description?: string | null;
  isTemplate?: boolean | null;
  archived?: boolean | null;
  readonly?: boolean | null;
  unresolvedIssues?: number | null;
  progress?: number | null;
  checklists?: ChecklistDto[] | null;
  projectTypeCode?: string | null;
  facilityCode?: string | null;
  projectTypesAllowed?: string[] | null;
  facilityRestrictions?: string[] | null;
  jobId?: number | null;
  options?: string | null;
  conditions?: string | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export enum ChecklistType {
  Standard = "standard",
  Repetitive = "repetitive",
  Cavity = "cavity",
  Core = "core",
}

export class FacilityDto implements IFacilityDto {
  code!: string;
  name!: string;
  archived?: boolean;

  constructor(data?: IFacilityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
    }
  }

  static fromJS(data: any): FacilityDto {
    data = typeof data === 'object' ? data : {};
    let result = new FacilityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code !== undefined ? this.code : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    return data;
  }
}

export interface IFacilityDto {
  code: string;
  name: string;
  archived?: boolean;
}

export class Issue implements IIssue {
  id?: number;
  questionId?: number;
  notes?: string | null;
  imageUrl?: string | null;
  resolved?: boolean;
  readonly createdOn?: moment.Moment;
  readonly createdBy?: string | null;
  readonly updatedOn?: moment.Moment;
  readonly updatedBy?: string | null;

  constructor(data?: IIssue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
      this.resolved = _data["resolved"] !== undefined ? _data["resolved"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
    }
  }

  static fromJS(data: any): Issue {
    data = typeof data === 'object' ? data : {};
    let result = new Issue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
    data["resolved"] = this.resolved !== undefined ? this.resolved : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    return data;
  }
}

export interface IIssue {
  id?: number;
  questionId?: number;
  notes?: string | null;
  imageUrl?: string | null;
  resolved?: boolean;
  createdOn?: moment.Moment;
  createdBy?: string | null;
  updatedOn?: moment.Moment;
  updatedBy?: string | null;
}

export class IssueDto implements IIssueDto {
  id?: number;
  questionId?: number;
  notes?: string | null;
  readonly imageUrl?: string | null;
  imageData?: string | null;
  resolved?: boolean;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IIssueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
      this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
      (<any>this).imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
      this.imageData = _data["imageData"] !== undefined ? _data["imageData"] : <any>null;
      this.resolved = _data["resolved"] !== undefined ? _data["resolved"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): IssueDto {
    data = typeof data === 'object' ? data : {};
    let result = new IssueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
    data["notes"] = this.notes !== undefined ? this.notes : <any>null;
    data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
    data["imageData"] = this.imageData !== undefined ? this.imageData : <any>null;
    data["resolved"] = this.resolved !== undefined ? this.resolved : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IIssueDto {
  id?: number;
  questionId?: number;
  notes?: string | null;
  imageUrl?: string | null;
  imageData?: string | null;
  resolved?: boolean;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class JobChecklistProject implements IJobChecklistProject {
  jobId?: number;
  checklistProjectId?: number;
  projectTypeCode!: string;
  conditions?: string | null;
  sortOrder?: number;

  constructor(data?: IJobChecklistProject) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
      this.checklistProjectId = _data["checklistProjectId"] !== undefined ? _data["checklistProjectId"] : <any>null;
      this.projectTypeCode = _data["projectTypeCode"] !== undefined ? _data["projectTypeCode"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
    }
  }

  static fromJS(data: any): JobChecklistProject {
    data = typeof data === 'object' ? data : {};
    let result = new JobChecklistProject();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
    data["checklistProjectId"] = this.checklistProjectId !== undefined ? this.checklistProjectId : <any>null;
    data["projectTypeCode"] = this.projectTypeCode !== undefined ? this.projectTypeCode : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    return data;
  }
}

export interface IJobChecklistProject {
  jobId?: number;
  checklistProjectId?: number;
  projectTypeCode: string;
  conditions?: string | null;
  sortOrder?: number;
}

export class JobChecklistProjectDto implements IJobChecklistProjectDto {
  jobId?: number;
  checklistProjectId?: number;
  conditions?: string | null;
  projectTypeCode?: string | null;
  sortOrder?: number;

  constructor(data?: IJobChecklistProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobId = _data["jobId"] !== undefined ? _data["jobId"] : <any>null;
      this.checklistProjectId = _data["checklistProjectId"] !== undefined ? _data["checklistProjectId"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      this.projectTypeCode = _data["projectTypeCode"] !== undefined ? _data["projectTypeCode"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
    }
  }

  static fromJS(data: any): JobChecklistProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobChecklistProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobId"] = this.jobId !== undefined ? this.jobId : <any>null;
    data["checklistProjectId"] = this.checklistProjectId !== undefined ? this.checklistProjectId : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["projectTypeCode"] = this.projectTypeCode !== undefined ? this.projectTypeCode : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    return data;
  }
}

export interface IJobChecklistProjectDto {
  jobId?: number;
  checklistProjectId?: number;
  conditions?: string | null;
  projectTypeCode?: string | null;
  sortOrder?: number;
}

export class JobDto implements IJobDto {
  jobNum?: string | null;
  wo?: string | null;
  woDate?: moment.Moment | null;
  facilityCode?: string | null;
  facility?: FacilityDto | null;
  checklistProjects?: ChecklistProjectDto[] | null;
  id?: number;
  name?: string | null;
  archived?: boolean;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IJobDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobNum = _data["jobNum"] !== undefined ? _data["jobNum"] : <any>null;
      this.wo = _data["wo"] !== undefined ? _data["wo"] : <any>null;
      this.woDate = _data["woDate"] ? moment(_data["woDate"].toString()) : <any>null;
      this.facilityCode = _data["facilityCode"] !== undefined ? _data["facilityCode"] : <any>null;
      this.facility = _data["facility"] ? FacilityDto.fromJS(_data["facility"]) : <any>null;
      if (Array.isArray(_data["checklistProjects"])) {
        this.checklistProjects = [] as any;
        for (let item of _data["checklistProjects"])
          this.checklistProjects!.push(ChecklistProjectDto.fromJS(item));
      }
      else {
        this.checklistProjects = <any>null;
      }
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): JobDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobNum"] = this.jobNum !== undefined ? this.jobNum : <any>null;
    data["wo"] = this.wo !== undefined ? this.wo : <any>null;
    data["woDate"] = this.woDate ? this.woDate.toISOString() : <any>null;
    data["facilityCode"] = this.facilityCode !== undefined ? this.facilityCode : <any>null;
    data["facility"] = this.facility ? this.facility.toJSON() : <any>null;
    if (Array.isArray(this.checklistProjects)) {
      data["checklistProjects"] = [];
      for (let item of this.checklistProjects)
        data["checklistProjects"].push(item.toJSON());
    }
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IJobDto {
  jobNum?: string | null;
  wo?: string | null;
  woDate?: moment.Moment | null;
  facilityCode?: string | null;
  facility?: FacilityDto | null;
  checklistProjects?: ChecklistProjectDto[] | null;
  id?: number;
  name?: string | null;
  archived?: boolean;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class JobTemplateDto implements IJobTemplateDto {
  templateJobs?: JobChecklistProjectDto[] | null;
  templateChecklistProjects?: ChecklistProjectDto[] | null;
  facilityRestrictions?: string[] | null;
  options?: string | null;
  id?: number;
  name?: string | null;
  archived?: boolean;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IJobTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["templateJobs"])) {
        this.templateJobs = [] as any;
        for (let item of _data["templateJobs"])
          this.templateJobs!.push(JobChecklistProjectDto.fromJS(item));
      }
      else {
        this.templateJobs = <any>null;
      }
      if (Array.isArray(_data["templateChecklistProjects"])) {
        this.templateChecklistProjects = [] as any;
        for (let item of _data["templateChecklistProjects"])
          this.templateChecklistProjects!.push(ChecklistProjectDto.fromJS(item));
      }
      else {
        this.templateChecklistProjects = <any>null;
      }
      if (Array.isArray(_data["facilityRestrictions"])) {
        this.facilityRestrictions = [] as any;
        for (let item of _data["facilityRestrictions"])
          this.facilityRestrictions!.push(item);
      }
      else {
        this.facilityRestrictions = <any>null;
      }
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): JobTemplateDto {
    data = typeof data === 'object' ? data : {};
    let result = new JobTemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.templateJobs)) {
      data["templateJobs"] = [];
      for (let item of this.templateJobs)
        data["templateJobs"].push(item.toJSON());
    }
    if (Array.isArray(this.templateChecklistProjects)) {
      data["templateChecklistProjects"] = [];
      for (let item of this.templateChecklistProjects)
        data["templateChecklistProjects"].push(item.toJSON());
    }
    if (Array.isArray(this.facilityRestrictions)) {
      data["facilityRestrictions"] = [];
      for (let item of this.facilityRestrictions)
        data["facilityRestrictions"].push(item);
    }
    data["options"] = this.options !== undefined ? this.options : <any>null;
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IJobTemplateDto {
  templateJobs?: JobChecklistProjectDto[] | null;
  templateChecklistProjects?: ChecklistProjectDto[] | null;
  facilityRestrictions?: string[] | null;
  options?: string | null;
  id?: number;
  name?: string | null;
  archived?: boolean;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class LoginCredentials implements ILoginCredentials {
  username?: string | null;
  password?: string | null;

  constructor(data?: ILoginCredentials) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
      this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
    }
  }

  static fromJS(data: any): LoginCredentials {
    data = typeof data === 'object' ? data : {};
    let result = new LoginCredentials();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["username"] = this.username !== undefined ? this.username : <any>null;
    data["password"] = this.password !== undefined ? this.password : <any>null;
    return data;
  }
}

export interface ILoginCredentials {
  username?: string | null;
  password?: string | null;
}

export class LookupListDto implements ILookupListDto {
  id?: number;
  name!: string;
  description?: string | null;
  options?: string | null;

  constructor(data?: ILookupListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
    }
  }

  static fromJS(data: any): LookupListDto {
    data = typeof data === 'object' ? data : {};
    let result = new LookupListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    return data;
  }
}

export interface ILookupListDto {
  id?: number;
  name: string;
  description?: string | null;
  options?: string | null;
}

export class MachineDto implements IMachineDto {
  id?: string | null;
  name?: string | null;

  constructor(data?: IMachineDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): MachineDto {
    data = typeof data === 'object' ? data : {};
    let result = new MachineDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IMachineDto {
  id?: string | null;
  name?: string | null;
}

export class Operation implements IOperation {
  value?: any | null;
  path?: string | null;
  op?: string | null;
  from?: string | null;

  constructor(data?: IOperation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.path = _data["path"] !== undefined ? _data["path"] : <any>null;
      this.op = _data["op"] !== undefined ? _data["op"] : <any>null;
      this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
    }
  }

  static fromJS(data: any): Operation {
    data = typeof data === 'object' ? data : {};
    let result = new Operation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["path"] = this.path !== undefined ? this.path : <any>null;
    data["op"] = this.op !== undefined ? this.op : <any>null;
    data["from"] = this.from !== undefined ? this.from : <any>null;
    return data;
  }
}

export interface IOperation {
  value?: any | null;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export class ProjectChecklistProject implements IProjectChecklistProject {
  projectId?: string | null;
  checklistProjectId?: number;
  projectTypeCode?: string | null;
  conditions?: string | null;
  sortOrder?: number;

  constructor(data?: IProjectChecklistProject) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
      this.checklistProjectId = _data["checklistProjectId"] !== undefined ? _data["checklistProjectId"] : <any>null;
      this.projectTypeCode = _data["projectTypeCode"] !== undefined ? _data["projectTypeCode"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
    }
  }

  static fromJS(data: any): ProjectChecklistProject {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectChecklistProject();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
    data["checklistProjectId"] = this.checklistProjectId !== undefined ? this.checklistProjectId : <any>null;
    data["projectTypeCode"] = this.projectTypeCode !== undefined ? this.projectTypeCode : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    return data;
  }
}

export interface IProjectChecklistProject {
  projectId?: string | null;
  checklistProjectId?: number;
  projectTypeCode?: string | null;
  conditions?: string | null;
  sortOrder?: number;
}

export class ProjectChecklistProjectDto implements IProjectChecklistProjectDto {
  projectId?: string | null;
  checklistProjectId?: number;
  conditions?: string | null;
  projectTypeCode?: string | null;
  sortOrder?: number;

  constructor(data?: IProjectChecklistProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
      this.checklistProjectId = _data["checklistProjectId"] !== undefined ? _data["checklistProjectId"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      this.projectTypeCode = _data["projectTypeCode"] !== undefined ? _data["projectTypeCode"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
    }
  }

  static fromJS(data: any): ProjectChecklistProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectChecklistProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
    data["checklistProjectId"] = this.checklistProjectId !== undefined ? this.checklistProjectId : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    data["projectTypeCode"] = this.projectTypeCode !== undefined ? this.projectTypeCode : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    return data;
  }
}

export interface IProjectChecklistProjectDto {
  projectId?: string | null;
  checklistProjectId?: number;
  conditions?: string | null;
  projectTypeCode?: string | null;
  sortOrder?: number;
}

export class ProjectDto implements IProjectDto {
  projectId!: string;
  wo?: string | null;
  woDate?: moment.Moment | null;
  name!: string;
  facilityCode?: string | null;
  archived?: boolean | null;
  templateProjects?: ProjectChecklistProjectDto[] | null;
  checklistProjects?: ChecklistProjectDto[] | null;
  isTemplate?: boolean | null;
  facilityRestrictions?: string[] | null;
  options?: string | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IProjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
      this.wo = _data["wo"] !== undefined ? _data["wo"] : <any>null;
      this.woDate = _data["woDate"] ? moment(_data["woDate"].toString()) : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.facilityCode = _data["facilityCode"] !== undefined ? _data["facilityCode"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      if (Array.isArray(_data["templateProjects"])) {
        this.templateProjects = [] as any;
        for (let item of _data["templateProjects"])
          this.templateProjects!.push(ProjectChecklistProjectDto.fromJS(item));
      }
      else {
        this.templateProjects = <any>null;
      }
      if (Array.isArray(_data["checklistProjects"])) {
        this.checklistProjects = [] as any;
        for (let item of _data["checklistProjects"])
          this.checklistProjects!.push(ChecklistProjectDto.fromJS(item));
      }
      else {
        this.checklistProjects = <any>null;
      }
      this.isTemplate = _data["isTemplate"] !== undefined ? _data["isTemplate"] : <any>null;
      if (Array.isArray(_data["facilityRestrictions"])) {
        this.facilityRestrictions = [] as any;
        for (let item of _data["facilityRestrictions"])
          this.facilityRestrictions!.push(item);
      }
      else {
        this.facilityRestrictions = <any>null;
      }
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): ProjectDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
    data["wo"] = this.wo !== undefined ? this.wo : <any>null;
    data["woDate"] = this.woDate ? this.woDate.toISOString() : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["facilityCode"] = this.facilityCode !== undefined ? this.facilityCode : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    if (Array.isArray(this.templateProjects)) {
      data["templateProjects"] = [];
      for (let item of this.templateProjects)
        data["templateProjects"].push(item.toJSON());
    }
    if (Array.isArray(this.checklistProjects)) {
      data["checklistProjects"] = [];
      for (let item of this.checklistProjects)
        data["checklistProjects"].push(item.toJSON());
    }
    data["isTemplate"] = this.isTemplate !== undefined ? this.isTemplate : <any>null;
    if (Array.isArray(this.facilityRestrictions)) {
      data["facilityRestrictions"] = [];
      for (let item of this.facilityRestrictions)
        data["facilityRestrictions"].push(item);
    }
    data["options"] = this.options !== undefined ? this.options : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IProjectDto {
  projectId: string;
  wo?: string | null;
  woDate?: moment.Moment | null;
  name: string;
  facilityCode?: string | null;
  archived?: boolean | null;
  templateProjects?: ProjectChecklistProjectDto[] | null;
  checklistProjects?: ChecklistProjectDto[] | null;
  isTemplate?: boolean | null;
  facilityRestrictions?: string[] | null;
  options?: string | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class ProjectTypeDto implements IProjectTypeDto {
  code?: string | null;
  name?: string | null;
  useMainChecklistSection?: boolean | null;
  allowIssuesSection?: boolean | null;
  allowRepeatChecklists?: boolean | null;
  repeatSectionTabName?: string | null;
  archived?: boolean;
  sortOrder?: number;

  constructor(data?: IProjectTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.useMainChecklistSection = _data["useMainChecklistSection"] !== undefined ? _data["useMainChecklistSection"] : <any>null;
      this.allowIssuesSection = _data["allowIssuesSection"] !== undefined ? _data["allowIssuesSection"] : <any>null;
      this.allowRepeatChecklists = _data["allowRepeatChecklists"] !== undefined ? _data["allowRepeatChecklists"] : <any>null;
      this.repeatSectionTabName = _data["repeatSectionTabName"] !== undefined ? _data["repeatSectionTabName"] : <any>null;
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
    }
  }

  static fromJS(data: any): ProjectTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code !== undefined ? this.code : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["useMainChecklistSection"] = this.useMainChecklistSection !== undefined ? this.useMainChecklistSection : <any>null;
    data["allowIssuesSection"] = this.allowIssuesSection !== undefined ? this.allowIssuesSection : <any>null;
    data["allowRepeatChecklists"] = this.allowRepeatChecklists !== undefined ? this.allowRepeatChecklists : <any>null;
    data["repeatSectionTabName"] = this.repeatSectionTabName !== undefined ? this.repeatSectionTabName : <any>null;
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    return data;
  }
}

export interface IProjectTypeDto {
  code?: string | null;
  name?: string | null;
  useMainChecklistSection?: boolean | null;
  allowIssuesSection?: boolean | null;
  allowRepeatChecklists?: boolean | null;
  repeatSectionTabName?: string | null;
  archived?: boolean;
  sortOrder?: number;
}

export class Question implements IQuestion {
  id?: number;
  areaId?: number;
  area?: ChecklistArea | null;
  prompt?: string | null;
  hint?: string | null;
  type!: QuestionType;
  lookupListId?: number | null;
  sortOrder?: number;
  value?: number | null;
  textValue?: string | null;
  conditions?: string | null;
  issues?: Issue[] | null;
  attachments?: QuestionAttachment[] | null;
  moreInfoId?: number | null;
  readonly createdOn?: moment.Moment;
  readonly createdBy?: string | null;
  readonly updatedOn?: moment.Moment;
  readonly updatedBy?: string | null;

  constructor(data?: IQuestion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
      this.area = _data["area"] ? ChecklistArea.fromJS(_data["area"]) : <any>null;
      this.prompt = _data["prompt"] !== undefined ? _data["prompt"] : <any>null;
      this.hint = _data["hint"] !== undefined ? _data["hint"] : <any>null;
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.lookupListId = _data["lookupListId"] !== undefined ? _data["lookupListId"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.textValue = _data["textValue"] !== undefined ? _data["textValue"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      if (Array.isArray(_data["issues"])) {
        this.issues = [] as any;
        for (let item of _data["issues"])
          this.issues!.push(Issue.fromJS(item));
      }
      else {
        this.issues = <any>null;
      }
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(QuestionAttachment.fromJS(item));
      }
      else {
        this.attachments = <any>null;
      }
      this.moreInfoId = _data["moreInfoId"] !== undefined ? _data["moreInfoId"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
    }
  }

  static fromJS(data: any): Question {
    data = typeof data === 'object' ? data : {};
    let result = new Question();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
    data["area"] = this.area ? this.area.toJSON() : <any>null;
    data["prompt"] = this.prompt !== undefined ? this.prompt : <any>null;
    data["hint"] = this.hint !== undefined ? this.hint : <any>null;
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["lookupListId"] = this.lookupListId !== undefined ? this.lookupListId : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["textValue"] = this.textValue !== undefined ? this.textValue : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    if (Array.isArray(this.issues)) {
      data["issues"] = [];
      for (let item of this.issues)
        data["issues"].push(item.toJSON());
    }
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    data["moreInfoId"] = this.moreInfoId !== undefined ? this.moreInfoId : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    return data;
  }
}

export interface IQuestion {
  id?: number;
  areaId?: number;
  area?: ChecklistArea | null;
  prompt?: string | null;
  hint?: string | null;
  type: QuestionType;
  lookupListId?: number | null;
  sortOrder?: number;
  value?: number | null;
  textValue?: string | null;
  conditions?: string | null;
  issues?: Issue[] | null;
  attachments?: QuestionAttachment[] | null;
  moreInfoId?: number | null;
  createdOn?: moment.Moment;
  createdBy?: string | null;
  updatedOn?: moment.Moment;
  updatedBy?: string | null;
}

export class QuestionAttachment implements IQuestionAttachment {
  id?: number;
  questionId?: number;
  question?: Question | null;
  fileName?: string | null;
  fileType?: string | null;
  filePath?: string | null;

  constructor(data?: IQuestionAttachment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
      this.question = _data["question"] ? Question.fromJS(_data["question"]) : <any>null;
      this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
      this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
      this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
    }
  }

  static fromJS(data: any): QuestionAttachment {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionAttachment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
    data["question"] = this.question ? this.question.toJSON() : <any>null;
    data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
    data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
    data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
    return data;
  }
}

export interface IQuestionAttachment {
  id?: number;
  questionId?: number;
  question?: Question | null;
  fileName?: string | null;
  fileType?: string | null;
  filePath?: string | null;
}

export class QuestionAttachmentDto implements IQuestionAttachmentDto {
  id?: number;
  questionId?: number;
  fileName?: string | null;
  fileType?: string | null;
  filePath?: string | null;
  attachmentData?: string | null;

  constructor(data?: IQuestionAttachmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : <any>null;
      this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
      this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
      this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
      this.attachmentData = _data["attachmentData"] !== undefined ? _data["attachmentData"] : <any>null;
    }
  }

  static fromJS(data: any): QuestionAttachmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionAttachmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["questionId"] = this.questionId !== undefined ? this.questionId : <any>null;
    data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
    data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
    data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
    data["attachmentData"] = this.attachmentData !== undefined ? this.attachmentData : <any>null;
    return data;
  }
}

export interface IQuestionAttachmentDto {
  id?: number;
  questionId?: number;
  fileName?: string | null;
  fileType?: string | null;
  filePath?: string | null;
  attachmentData?: string | null;
}

export class QuestionDto implements IQuestionDto {
  id?: number | null;
  areaId?: number | null;
  prompt?: string | null;
  hint?: string | null;
  type!: QuestionType;
  lookupListId?: number | null;
  sortOrder?: number;
  value?: number | null;
  textValue?: string | null;
  conditions?: string | null;
  issues?: IssueDto[] | null;
  attachments?: QuestionAttachmentDto[] | null;
  moreInfoId?: number | null;
  readonly createdBy?: string | null;
  readonly createdOn?: moment.Moment;
  readonly updatedBy?: string | null;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IQuestionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
      this.prompt = _data["prompt"] !== undefined ? _data["prompt"] : <any>null;
      this.hint = _data["hint"] !== undefined ? _data["hint"] : <any>null;
      this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
      this.lookupListId = _data["lookupListId"] !== undefined ? _data["lookupListId"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
      this.textValue = _data["textValue"] !== undefined ? _data["textValue"] : <any>null;
      this.conditions = _data["conditions"] !== undefined ? _data["conditions"] : <any>null;
      if (Array.isArray(_data["issues"])) {
        this.issues = [] as any;
        for (let item of _data["issues"])
          this.issues!.push(IssueDto.fromJS(item));
      }
      else {
        this.issues = <any>null;
      }
      if (Array.isArray(_data["attachments"])) {
        this.attachments = [] as any;
        for (let item of _data["attachments"])
          this.attachments!.push(QuestionAttachmentDto.fromJS(item));
      }
      else {
        this.attachments = <any>null;
      }
      this.moreInfoId = _data["moreInfoId"] !== undefined ? _data["moreInfoId"] : <any>null;
      (<any>this).createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedBy = _data["updatedBy"] !== undefined ? _data["updatedBy"] : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): QuestionDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
    data["prompt"] = this.prompt !== undefined ? this.prompt : <any>null;
    data["hint"] = this.hint !== undefined ? this.hint : <any>null;
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["lookupListId"] = this.lookupListId !== undefined ? this.lookupListId : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["value"] = this.value !== undefined ? this.value : <any>null;
    data["textValue"] = this.textValue !== undefined ? this.textValue : <any>null;
    data["conditions"] = this.conditions !== undefined ? this.conditions : <any>null;
    if (Array.isArray(this.issues)) {
      data["issues"] = [];
      for (let item of this.issues)
        data["issues"].push(item.toJSON());
    }
    if (Array.isArray(this.attachments)) {
      data["attachments"] = [];
      for (let item of this.attachments)
        data["attachments"].push(item.toJSON());
    }
    data["moreInfoId"] = this.moreInfoId !== undefined ? this.moreInfoId : <any>null;
    data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IQuestionDto {
  id?: number | null;
  areaId?: number | null;
  prompt?: string | null;
  hint?: string | null;
  type: QuestionType;
  lookupListId?: number | null;
  sortOrder?: number;
  value?: number | null;
  textValue?: string | null;
  conditions?: string | null;
  issues?: IssueDto[] | null;
  attachments?: QuestionAttachmentDto[] | null;
  moreInfoId?: number | null;
  createdBy?: string | null;
  createdOn?: moment.Moment;
  updatedBy?: string | null;
  updatedOn?: moment.Moment;
}

export class QuestionMoreInfoDto implements IQuestionMoreInfoDto {
  id?: number;
  html_en?: string | null;

  constructor(data?: IQuestionMoreInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.html_en = _data["html_en"] !== undefined ? _data["html_en"] : <any>null;
    }
  }

  static fromJS(data: any): QuestionMoreInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionMoreInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["html_en"] = this.html_en !== undefined ? this.html_en : <any>null;
    return data;
  }
}

export interface IQuestionMoreInfoDto {
  id?: number;
  html_en?: string | null;
}

export enum QuestionType {
  YesNo = "yesNo",
  YesNoNA = "yesNoNA",
  Textbox = "textbox",
  LookupList = "lookupList",
  FileUpload = "fileUpload",
}

export class RepetitiveChecklistDto implements IRepetitiveChecklistDto {
  id?: number;
  name!: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  areas?: ChecklistAreaDto[] | null;
  projectTypesAllowed?: string[] | null;
  checklistTypes?: ChecklistType[] | null;
  facilityRestrictions?: string[] | null;
  archived?: boolean;
  allowSignOff?: boolean | null;
  useSuggestions?: boolean;
  suggestionsLabel?: string | null;
  suggestions?: string[] | null;
  customSuggestions?: boolean | null;
  defaultNameFormat?: string | null;
  userEditableName?: boolean | null;

  constructor(data?: IRepetitiveChecklistDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.options = _data["options"] !== undefined ? _data["options"] : <any>null;
      if (Array.isArray(_data["areas"])) {
        this.areas = [] as any;
        for (let item of _data["areas"])
          this.areas!.push(ChecklistAreaDto.fromJS(item));
      }
      else {
        this.areas = <any>null;
      }
      if (Array.isArray(_data["projectTypesAllowed"])) {
        this.projectTypesAllowed = [] as any;
        for (let item of _data["projectTypesAllowed"])
          this.projectTypesAllowed!.push(item);
      }
      else {
        this.projectTypesAllowed = <any>null;
      }
      if (Array.isArray(_data["checklistTypes"])) {
        this.checklistTypes = [] as any;
        for (let item of _data["checklistTypes"])
          this.checklistTypes!.push(item);
      }
      else {
        this.checklistTypes = <any>null;
      }
      if (Array.isArray(_data["facilityRestrictions"])) {
        this.facilityRestrictions = [] as any;
        for (let item of _data["facilityRestrictions"])
          this.facilityRestrictions!.push(item);
      }
      else {
        this.facilityRestrictions = <any>null;
      }
      this.archived = _data["archived"] !== undefined ? _data["archived"] : <any>null;
      this.allowSignOff = _data["allowSignOff"] !== undefined ? _data["allowSignOff"] : <any>null;
      this.useSuggestions = _data["useSuggestions"] !== undefined ? _data["useSuggestions"] : <any>null;
      this.suggestionsLabel = _data["suggestionsLabel"] !== undefined ? _data["suggestionsLabel"] : <any>null;
      if (Array.isArray(_data["suggestions"])) {
        this.suggestions = [] as any;
        for (let item of _data["suggestions"])
          this.suggestions!.push(item);
      }
      else {
        this.suggestions = <any>null;
      }
      this.customSuggestions = _data["customSuggestions"] !== undefined ? _data["customSuggestions"] : <any>null;
      this.defaultNameFormat = _data["defaultNameFormat"] !== undefined ? _data["defaultNameFormat"] : <any>null;
      this.userEditableName = _data["userEditableName"] !== undefined ? _data["userEditableName"] : <any>null;
    }
  }

  static fromJS(data: any): RepetitiveChecklistDto {
    data = typeof data === 'object' ? data : {};
    let result = new RepetitiveChecklistDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["description"] = this.description !== undefined ? this.description : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["options"] = this.options !== undefined ? this.options : <any>null;
    if (Array.isArray(this.areas)) {
      data["areas"] = [];
      for (let item of this.areas)
        data["areas"].push(item.toJSON());
    }
    if (Array.isArray(this.projectTypesAllowed)) {
      data["projectTypesAllowed"] = [];
      for (let item of this.projectTypesAllowed)
        data["projectTypesAllowed"].push(item);
    }
    if (Array.isArray(this.checklistTypes)) {
      data["checklistTypes"] = [];
      for (let item of this.checklistTypes)
        data["checklistTypes"].push(item);
    }
    if (Array.isArray(this.facilityRestrictions)) {
      data["facilityRestrictions"] = [];
      for (let item of this.facilityRestrictions)
        data["facilityRestrictions"].push(item);
    }
    data["archived"] = this.archived !== undefined ? this.archived : <any>null;
    data["allowSignOff"] = this.allowSignOff !== undefined ? this.allowSignOff : <any>null;
    data["useSuggestions"] = this.useSuggestions !== undefined ? this.useSuggestions : <any>null;
    data["suggestionsLabel"] = this.suggestionsLabel !== undefined ? this.suggestionsLabel : <any>null;
    if (Array.isArray(this.suggestions)) {
      data["suggestions"] = [];
      for (let item of this.suggestions)
        data["suggestions"].push(item);
    }
    data["customSuggestions"] = this.customSuggestions !== undefined ? this.customSuggestions : <any>null;
    data["defaultNameFormat"] = this.defaultNameFormat !== undefined ? this.defaultNameFormat : <any>null;
    data["userEditableName"] = this.userEditableName !== undefined ? this.userEditableName : <any>null;
    return data;
  }
}

export interface IRepetitiveChecklistDto {
  id?: number;
  name: string;
  description?: string | null;
  sortOrder?: number;
  options?: string | null;
  areas?: ChecklistAreaDto[] | null;
  projectTypesAllowed?: string[] | null;
  checklistTypes?: ChecklistType[] | null;
  facilityRestrictions?: string[] | null;
  archived?: boolean;
  allowSignOff?: boolean | null;
  useSuggestions?: boolean;
  suggestionsLabel?: string | null;
  suggestions?: string[] | null;
  customSuggestions?: boolean | null;
  defaultNameFormat?: string | null;
  userEditableName?: boolean | null;
}

export class SnlrHeaders implements ISnlrHeaders {
  snlrConnectionId?: string | null;
  snlrGroupId?: string | null;
  readonly hasGroupId?: boolean;
  readonly hasConnectionId?: boolean;

  constructor(data?: ISnlrHeaders) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.snlrConnectionId = _data["snlrConnectionId"] !== undefined ? _data["snlrConnectionId"] : <any>null;
      this.snlrGroupId = _data["snlrGroupId"] !== undefined ? _data["snlrGroupId"] : <any>null;
      (<any>this).hasGroupId = _data["hasGroupId"] !== undefined ? _data["hasGroupId"] : <any>null;
      (<any>this).hasConnectionId = _data["hasConnectionId"] !== undefined ? _data["hasConnectionId"] : <any>null;
    }
  }

  static fromJS(data: any): SnlrHeaders {
    data = typeof data === 'object' ? data : {};
    let result = new SnlrHeaders();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["snlrConnectionId"] = this.snlrConnectionId !== undefined ? this.snlrConnectionId : <any>null;
    data["snlrGroupId"] = this.snlrGroupId !== undefined ? this.snlrGroupId : <any>null;
    data["hasGroupId"] = this.hasGroupId !== undefined ? this.hasGroupId : <any>null;
    data["hasConnectionId"] = this.hasConnectionId !== undefined ? this.hasConnectionId : <any>null;
    return data;
  }
}

export interface ISnlrHeaders {
  snlrConnectionId?: string | null;
  snlrGroupId?: string | null;
  hasGroupId?: boolean;
  hasConnectionId?: boolean;
}

export class UserDto implements IUserDto {
  id?: number;
  userName!: string;
  newPassword?: string | null;
  name?: string | null;
  email?: string | null;
  facilityCode?: string | null;
  role?: UserRole;
  superUser?: boolean;
  disabled?: boolean;
  readonly createdOn?: moment.Moment;
  readonly updatedOn?: moment.Moment;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
      this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
      this.facilityCode = _data["facilityCode"] !== undefined ? _data["facilityCode"] : <any>null;
      this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
      this.superUser = _data["superUser"] !== undefined ? _data["superUser"] : <any>null;
      this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
      (<any>this).createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
      (<any>this).updatedOn = _data["updatedOn"] ? moment(_data["updatedOn"].toString()) : <any>null;
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["userName"] = this.userName !== undefined ? this.userName : <any>null;
    data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["email"] = this.email !== undefined ? this.email : <any>null;
    data["facilityCode"] = this.facilityCode !== undefined ? this.facilityCode : <any>null;
    data["role"] = this.role !== undefined ? this.role : <any>null;
    data["superUser"] = this.superUser !== undefined ? this.superUser : <any>null;
    data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
    data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>null;
    return data;
  }
}

export interface IUserDto {
  id?: number;
  userName: string;
  newPassword?: string | null;
  name?: string | null;
  email?: string | null;
  facilityCode?: string | null;
  role?: UserRole;
  superUser?: boolean;
  disabled?: boolean;
  createdOn?: moment.Moment;
  updatedOn?: moment.Moment;
}

export enum UserRole {
  User = "user",
  Manager = "manager",
  Pm = "pm",
  Admin = "admin",
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}